import { Component, ElementRef, Input, NgZone, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { DataService } from 'src/app/_helpers';
import { AuthService } from 'src/app/_services';

@Component({
  selector: 'app-new-notificactions-version',
  templateUrl: './new-notificactions-version.component.html',
  styleUrls: [
    './new-notificactions-version.component.css',
    '../../../../assets/css/new-component-view.css'
  ]
})
export class NewNotificactionsVersionComponent implements OnInit, OnDestroy {

  @Input() customerPublicId: string;
  activeTab: string | null = null;
  tabOffsetLeft: number;
  tabOffsetWidth: number;
  private destroy$ = new Subject<void>();
  items: string[] = ['Plantillas', 'Programación de notificaciones'];
  @ViewChildren('tabItem') tabItems: QueryList<ElementRef>;
  sectionDisplayed: 'LIST' | 'CREATE-FORM' | 'EDIT-DUPLICATE-FORM';

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private dataService: DataService
  ) {
  }

  ngOnInit() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    } else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    }
    this.initTabLinePosition(this.items[0]);
    this.dataService.displayTemplateSection('LIST');
    this.setDisplayTemplateSectionSubject();
  }

  setDisplayTemplateSectionSubject() {
    this.dataService.displayTemplateSectionSubject$
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          this.sectionDisplayed = data;
        })
      ).subscribe();
  }

  initTabLinePosition(tabName: string) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.setActiveTab(tabName);
      });
    });
  }

  setActiveTab(tabName: string) {
    this.activeTab = tabName;
    const tabItem = this.tabItems.toArray().find(item => item.nativeElement.getAttribute('data-id') === tabName).nativeElement as HTMLElement;
    if (tabItem) {
      this.tabOffsetLeft = tabItem.offsetLeft;
      this.tabOffsetWidth = tabItem.offsetWidth;
    }
    if (this.activeTab !== 'Plantillas') {
      this.dataService.displayTemplateSection('LIST');
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
